export default "__VITE_ASSET__BG$Xb3Gm__";